exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".phone[data-v-cf5f36f4]{position:relative;padding-top:30px;box-sizing:border-box}.phone.mb[data-v-cf5f36f4]{padding-top:0}\n", ""]);

